module.exports = __webpack_public_path__ + "media/images/pic/certificates/qafp-79e090b6aa53b1dde2fe48c1a7e36ecd.png";